import { combineReducers } from 'redux';
import alertReducer from './alert/alert-reducer';
import profileReducer from './profile/profile-reducer';
import homepageReducer from './homepage/homepage-reducer';
import expsByCountryReducer from './expsByCountry/countriesVisited-reducer';
import editExpReducer from './editExp/editExp-reducer';
import notificationsReducer from './notifications/notifications-reducer';
import searchReducer from './search/search-reducer';


export default combineReducers({
  alerts: alertReducer,
  profile: profileReducer,
  homepage: homepageReducer,
  expsByCountryPage: expsByCountryReducer,
  editExp: editExpReducer,
  notifications: notificationsReducer,
  search: searchReducer
});